import type { Permission } from '@gql'
import type { IntlShape } from 'react-intl'

import { createConfigurationMenu } from './index'

export const getConfigMenuItemsPermissions = (intl: IntlShape): Permission[] =>
  createConfigurationMenu(intl)
    .reduce(
      (prev, { menuItems }) => [...prev, ...menuItems.map(({ permissions }) => permissions)],
      [],
    )
    .flat()
